// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-1068f51e] .bj-page .el-form-item__label {\n  display: none;\n}\n.order-tags-tooltip[data-v-1068f51e] {\n  overflow: hidden;\n}", ""]);
// Exports
module.exports = exports;
